import React from "react";
import { MdImageNotSupported } from "react-icons/md";
import { FaCaretDown } from "react-icons/fa6";
import useThemeColors from "../../hooks/useThemeColors";
import {
  Flex,
  Text,
  Image,
  Box,
  Icon,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { backgroundLight, primaryAlt, textSecondary } from "../../utils/colors";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { TbDental } from "react-icons/tb";

const HeaderTenantSwitchMobile = ({
  slug,
  tenant,
  clinicName,
  userInfo,
  handleTenantSwitch,
  closeDrawer,
}) => {
  const { textPrimaryMode, newBorderMode } = useThemeColors();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {userInfo?.tenants?.length > 1 ? (
        <Menu placement="bottom-start">
          {({ isOpen }) => (
            <>
              <MenuButton
                as={Button}
                variant="ghost"
                // w="100%"
                textAlign="left"
                p="1.75rem 0rem"
                _hover={{ bg: backgroundLight, p: "1.75rem 0.5rem" }}
                _active={{ bg: backgroundLight, p: "1.75rem 0.5rem" }}
                transition="all 0.2s ease"
                borderRadius="0.75rem"
                role="group"
              >
                <Flex align="center" justify="space-between">
                  <Flex align="center">
                    {tenant?.logo ? (
                      <Image
                        src={tenant.logo}
                        alt={clinicName}
                        w="2.25rem"
                        h="2.25rem"
                        borderRadius="0.75rem"
                        objectFit="cover"
                        mr="0.5rem"
                      />
                    ) : (
                      <Flex
                        align="center"
                        justify="center"
                        h="2.5rem"
                        w="2.5rem"
                        borderRadius="100%"
                        bg={backgroundLight}
                        // border={`1px solid ${newBorder}`}
                        mr="0.5rem"
                      >
                        <Icon
                          as={TbDental}
                          color={textSecondary}
                          fontSize="0.875rem"
                        />
                      </Flex>
                    )}

                    <Flex direction="column" align="flex-start">
                      <Text
                        fontWeight="600"
                        color={textPrimaryMode}
                        fontSize="sm"
                        isTruncated
                        maxW="160px"
                      >
                        {clinicName}
                      </Text>
                      <Text fontSize="xs" color={textSecondary}>
                        {
                          userInfo?.tenants?.find(
                            (t) => t.tenantID === userInfo.tenantID
                          )?.role
                        }
                      </Text>
                    </Flex>
                  </Flex>

                  {/* ▼ Caret */}
                  <Icon
                    as={FaCaretDown}
                    ml={2}
                    w="0.75rem"
                    h="0.75rem"
                    color={textSecondary}
                    transform={isOpen ? "rotate(-180deg)" : "rotate(0deg)"}
                    transition="all 0.2s ease"
                    opacity={0}
                    _groupHover={{
                      opacity: 1,
                      transform: isOpen ? "rotate(-180deg)" : "rotate(0deg)",
                    }}
                  />
                </Flex>
              </MenuButton>

              <MenuList p="1rem" m={0} borderRadius="1rem" overflow="hidden">
                {userInfo?.tenants?.map((tenant) => (
                  <MenuItem
                    key={tenant.tenantID}
                    onClick={() => handleTenantSwitch(t.slug)}
                    bg={
                      tenant.tenantID === userInfo.tenantID
                        ? "gray.50"
                        : "white"
                    }
                  >
                    <Flex direction="column">
                      <Text fontWeight="500" fontSize="md">
                        {tenant.slug}
                      </Text>
                      <Text fontSize="xs" color="gray.500">
                        {t(`role.${tenant.role}`)}
                      </Text>
                    </Flex>
                  </MenuItem>
                ))}
              </MenuList>
            </>
          )}
        </Menu>
      ) : (
        // <Link to={`/${slug}/settings/clinic-settings`}>
        <Flex
          align="center"
          // border={`1px solid ${newBorderMode}`}
          // p="1.75rem 0rem"
          h="3.5rem"
          borderRadius="0.75rem"
          // p="0 1rem"
          onClick={() => {
            navigate(`/${slug}/settings/clinic-settings`);
            closeDrawer();
          }}
        >
          {tenant && tenant.logo ? (
            <Flex
              w="2.25rem"
              h="2.25rem"
              align="center"
              justify="center"
              borderRadius="0.75rem"
              border={`0px solid ${newBorderMode}`}
              overflow="hidden"
              mr="0.75rem"
              flexShrink="0"
            >
              <Image
                src={tenant && tenant.logo}
                alt={clinicName}
                w="100%"
                h="100%"
                objectFit="cover"
              />
            </Flex>
          ) : (
            <Flex
              align="center"
              justify="center"
              h="2.5rem"
              w="2.5rem"
              borderRadius="100%"
              bg={backgroundLight}
              border={`1px solid ${newBorderMode}`}
              mr="0.5rem"
            >
              <Icon as={TbDental} color={textSecondary} fontSize="0.875rem" />
            </Flex>
          )}

          <Flex gap={1}>
            <Text
              fontSize={["md", "md"]}
              fontWeight="600"
              color={textPrimaryMode}
              lineHeight="1.2"
              maxW={["160px", "100%"]}
              isTruncated
              // noOfLines={2}
            >
              {clinicName}
            </Text>
          </Flex>
        </Flex>
        // </Link>
      )}
    </>
  );
};

export default HeaderTenantSwitchMobile;
